import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { RawHtmlInterface } from 'common/types/entities/RawHtmlInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createRawHtml(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): RawHtmlInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.RawHtml, parentId, masterBlockId),
    textAlign: 'center',
    html: '<h2>systeme.io</h2>',
  }
}
